<template>
    <Dialog>
        <template v-slot:title>
            {{ $t('message.title_edit_ai_setting') }}
        </template>

        <template v-slot:body>
            <AiAppSettingDefinitionForm
                v-model="form"
                :settingTitle="settingTitle"
                :helpHtmlUrl="helpHtmlUrl"
                @update:valid ="setButtonStatus($event)"
            />
        </template>

        <template v-slot:button>
            <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
            <el-button class="dialog-ok-button" @click="save" :disabled="disableSave" v-t="'message.button_save'"></el-button>
        </template>
    </Dialog>
</template>

<script>
import Dialog from "@/components/pc/common/Dialog";
import AiAppSettingUtility from "@/components/pc/setting/ai-app/AiAppSettingUtility";
import AiAppSettingDefinitionForm from "@/components/pc/setting/ai-app/AiAppSettingDefinitionEditForm";

export default {
    mixins:[ AiAppSettingUtility ],

    components: { Dialog, AiAppSettingDefinitionForm },

    props: {
        type: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            form: {
                displayName : null,
                sections: null,
            },
            disableSave: true,
        };
    },

    computed: {
        settingTitle() {
            return this.getSettingTitle(this.data.templateName)
        },
        helpHtmlUrl() {
            return this.getHelpHtmlUrl(this.data.helpHtml)
        }
    },

    created() {
        this.form.displayName = this.data.displayName
        this.form.sections = JSON.parse(JSON.stringify(this.data.sections)) // deep copy through JSON
        this.disableSave = true;
    },

    methods: {
        setButtonStatus(valid) {
            this.disableSave = !valid
        },
        save() {
            this.$emit('save', {displayName: this.form.displayName, sections: this.form.sections})
        }
    }
}

</script>

<style scoped>

</style>
